<template>
  <div>
    <TitlePage :title="$t('create')+' '+$t('promo-codes')"></TitlePage>

    <v-form @submit.prevent="save()" class="bb-gray pb-5" ref="form_create" v-model="check">
      <v-layout wrap>

        <v-flex md10 class="pl-4 pr-4">
          <v-text-field :label="$t('code')" v-model="item.code" :rules="[rules.required]"></v-text-field>
        </v-flex>

        <v-flex md2  class="pl-4 pr-4">
          <v-switch v-model="item.status" inset :label="$t('status')"></v-switch>
        </v-flex>

        <v-flex md2 class="pl-4 pr-4">
          <v-dialog
              ref="dialog_start"
              v-model="modal_start"
              :return-value.sync="item.date_start"
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="item.date_start"
                  label="Data di Inizio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker
                v-model="item.date_start"
                scrollable
                first-day-of-week="1"
                @input="onDateSelected('start', $event)"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_start = false">
                {{ $t('back') }}
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_start.save(item.date_start)">
                {{ $t('confirm') }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <!-- Data di Fine -->
        <v-flex md2 class="pl-4 pr-4">
          <v-dialog
              ref="dialog_end"
              v-model="modal_end"
              :return-value.sync="item.date_end"
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="item.date_end"
                  label="Data di Fine"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker
                v-model="item.date_end"
                scrollable
                first-day-of-week="1"
                @input="onDateSelected('end', $event)"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal_end = false">
                {{ $t('back') }}
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog_end.save(item.date_end)">
                {{ $t('confirm') }}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex md2  class="pl-4 pr-4">
          <v-select :items="promotion_types" :label="$t('mode')" v-model="item.type" :rules="[rules.required]" />
        </v-flex>
        <v-flex md2 class="pl-4 pr-4">
          <v-text-field type="number" :label="$t('value')" v-model="item.value" :prefix="(item.type == 'fixed') ? '-':'%'" step="1" min="1" max="100" :rules="[rules.number_gt_zero]"/>
        </v-flex>

        <v-flex md2 class="pl-4 pr-4">
          <v-text-field type="number" label="Numero MAX utilizzi generico" v-model="item.max_use_generic"  step="1" min="1" max="100" :rules="[rules.number_gt_zero]"/>
        </v-flex>

        <v-flex md2 class="pl-4 pr-4">
          <v-text-field type="number" label="Numero MAX utilizzi per utente" v-model="item.max_use_for_user" step="1" min="1" max="100" :rules="[rules.number_gt_zero]"/>
        </v-flex>

        <v-flex md2 class="pl-4 pr-4">
          <v-checkbox
              v-model="item.enable_promo_sa_global"
              label="Tipo uCamp"
              :readonly="!this.getUser.super_admin"
              :disabled="!this.getUser.super_admin"
          ></v-checkbox>
        </v-flex>

        <v-flex md2 class="pl-4 pr-4">
          <v-checkbox
              v-model="item.enable_promo_center"
              label="Tipo Centro Sportivo"
              :readonly="!this.getUser.super_admin"
              :disabled="!this.getUser.super_admin"
          ></v-checkbox>
        </v-flex>

        <v-flex md8 class="pl-4 pr-4"></v-flex>

        <v-flex md6 class="pl-4 pr-4">
          <CustomerAutocomplete
              @message="setResultCustomer"
          ></CustomerAutocomplete>
        </v-flex>

        <v-flex md6 class="pl-4 pr-4" v-if="getUser.super_admin">
          <CenterAutocomplete @message="setCenterId" :init-value="this.item.center_id"></CenterAutocomplete>
          <v-alert
              dense
              outlined
              type="error"
              v-if="center_settings.enable_promo_code_promo_sa_global === false || center_settings.enable_promo_code_promo_center === false"
          >
              <div style="font-size: 12px">
                <span v-if="center_settings.enable_promo_code_promo_sa_global === false">NON Accetta Promo Code uCamp </span><br/>
                <span v-if="center_settings.enable_promo_code_promo_center === false">NON Accetta Promo Code Centro</span>
              </div>
          </v-alert>
        </v-flex>

        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>

        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
          <v-btn elevation="2" color="primary" class="ml-auto" type="submit">
            {{ $t('save') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete.vue";
import CustomerAutocomplete from "@/components/admin/CustomerAutocomplete.vue";

export default {
  name: "CreatePromoCode",
  components: {CustomerAutocomplete, CenterAutocomplete, TitlePage},
  data() {
    return {
      customerToAdd: {},
      searchResults: [],
      isLoading: false,
      search: '',
      showHint: '',
      center_settings:{
        enable_promo_code_promo_center : null,
        enable_promo_code_promo_sa_global: null,
      },
      item: {
        code: '',
        type: '',
        value: 0.00,
        status: false,
        max_use_generic: 0,
        max_use_for_user: 0,
        num_use: 0,
        date_start: null,
        date_end: null,
        user_id: null,
        center_id: null,
        enable_promo_sa_global: false,
        enable_promo_center: false,
      },
      promotion_types: [
        {'text': '', 'value': null},
        {'text': this.$t('fixed'), 'value': 'fixed'},
        {'text': this.$t('percentage'), 'value': 'percentage'},
      ],
      check: true,
      rules: {
        required: value => !!value || this.$t('fillMandatory'),
        number_gt_zero: v => v > 0 || this.$t('fillMandatory'),
      },
      modal_start: false,
      modal_end: false,
    };
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id){
      this.item.center_id = this.getUser.center_id
      this.item.enable_promo_center = true
    }else if(this.getUser.super_admin) {
      this.item.enable_promo_sa_global = true
      this.item.enable_promo_center = true
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'promoCodes/store',
      'searchCustomer': 'customers/search',
      'editCenter': 'centers/edit'
    }),
    async setResultCustomer(id) {
        this.item.user_id = id
    },
    async setCenterId(id) {
      this.item.center_id = id
      const data = await this.editCenter({id: id})
      if(data.result){
        this.center_settings.enable_promo_code_promo_center = data.result.enable_promo_code_promo_center
        this.center_settings.enable_promo_code_promo_sa_global = data.result.enable_promo_code_promo_sa_global
      }else {
        this.center_settings.enable_promo_code_promo_center = null
        this.center_settings.enable_promo_code_promo_sa_global = null
      }
    },
    onDateSelected(which, date) {
      this[`modal_${which}`] = false;
      this.$refs[`dialog_${which}`].save(date);
    },
    async save(){

      this.$refs.form_create.validate()
      if(!this.check){
        return
      }

      await this.setLoading(true);
      let result = await this.storeItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        await this.$router.push('/promo-codes/')

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

  },
  mounted() {

  },
  watch: {
    search (val,oldVal) {

      if(val == null || val === "" || val.length <= 2) return;
      if(this.isLoading) return

      this.isLoading = true
      this.showHint = false

      setTimeout(()=> {

        this.searchResults = []

        this.searchCustomer({search: this.search}).then(result => {

          if(result.length > 0){
            result.map(x => this.searchResults.push({
              'desc': `${x.name} ${x.surname} - ${x.email} - ${x.phone}`,
              '_id': x._id
            }))
          }

          this.showHint = true
          this.isLoading = false
        })

      }, 1500);
    },
  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
  },
}
</script>

<style scoped>

</style>